import { ProgressSpinner } from "primereact/progressspinner";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";

const money = (value) =>
  Number(value || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

// Split a piece quantity into cartons plus loose pieces.
const asCarton = (qty, packSize) => {
  const size = Number(packSize) > 0 ? Number(packSize) : 1;
  const cartons = Math.floor(Number(qty || 0) / size);
  const pieces = Number(qty || 0) - cartons * size;
  return `${cartons} Crtn, ${pieces} Pcs`;
};

const Receipt = () => {
  const { id } = useParams();
  const [info, setInfo] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await Http.get(`/demand/${id}`);
        setInfo(res.data);
      } catch (e) {
        console.error("Fetch error:", e);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [id]);

  if (loading || !info) {
    return (
      <div className="am-mainpanel">
        <IsLogin></IsLogin>
        <div className="am-pagebody">{loading ? <ProgressSpinner /> : <p>Demand not found.</p>}</div>
      </div>
    );
  }

  const items = info.list || [];

  return (
    <div>
      <IsLogin></IsLogin>
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Demand No - {info.receipt_no}</h5>
          <button className="btn btn-default noPrint" onClick={() => window.print()}>
            <i className="fa fa-print"></i> &nbsp;Print
          </button>
        </div>

        <div className="am-pagebody">
          <div className="card pd-20 pd-sm-40">
            <div className="row">
              <div className="col-7">
                <table className="table table-sm table-borderless mb-0">
                  <tbody>
                    <tr>
                      <td width="35%">
                        <strong>Distributor Name</strong>
                      </td>
                      <td>: {info.distributor ? info.distributor.name : ""}</td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Distributor Id</strong>
                      </td>
                      <td>: {info.distributor ? info.distributor.code : ""}</td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Contact Person</strong>
                      </td>
                      <td>: {info.distributor ? info.distributor.contact_person : ""}</td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Phone</strong>
                      </td>
                      <td>: {info.distributor ? info.distributor.contact_phone : ""}</td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Address</strong>
                      </td>
                      <td>: {info.distributor ? info.distributor.godown_address : ""}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="col-5 text-right">
                Demand Date : {info.date} {info.time ? `(${info.time})` : ""}
                <br />
                Order Date : {info.order_date}
                <br />
                Demand No. : {info.receipt_no}
                <br />
                {info.sr ? `SR Name : ${info.sr.name}` : ""}
              </div>
            </div>

            <h5 className="text-center mt-3">
              <u>Demand Sheet</u>
            </h5>

            <div className="table-responsive mt-3">
              <table className="table table-sm table-bordered" style={{ fontSize: "12px" }}>
                <thead>
                  <tr style={{ backgroundColor: "#f1f1f1" }}>
                    <th>Sl.</th>
                    <th>Product Name</th>
                    <th className="text-right">Crtn Size</th>
                    <th className="text-right">Demand Qty (PCS)</th>
                    <th className="text-right">Demand Qty (CTN)</th>
                    <th className="text-right">Remaining Qty</th>
                    <th className="text-right">Remaining Qty (CTN)</th>
                    <th className="text-right">Unit Price</th>
                    <th className="text-right">Line Total</th>
                  </tr>
                </thead>
                <tbody>
                  {items.map((item, index) => (
                    <tr key={item.id}>
                      <td>{index + 1}</td>
                      <td>
                        {item.product ? item.product.name : ""}
                        {item.is_unavailable ? <span className="text-danger"> (Unavailable)</span> : ""}
                      </td>
                      <td className="text-right">{item.packsize}</td>
                      <td className="text-right">
                        {item.is_unavailable && item.qty_before_unavailable ? (
                          <>
                            <del className="text-danger">{money(item.qty_before_unavailable)}</del>
                            <br />
                          </>
                        ) : null}
                        {money(item.qty)}
                      </td>
                      <td className="text-right">{asCarton(item.invQty, item.packsize)}</td>
                      <td
                        className="text-right"
                        style={Number(item.remaining_qty) < 1 ? { color: "green", fontWeight: "bold" } : {}}
                      >
                        {money(item.remaining_qty)}
                      </td>
                      <td className="text-right">{asCarton(item.remaining_qty, item.packsize)}</td>
                      <td className="text-right">{money(item.rate)} BDT</td>
                      <td className="text-right">{money(item.price)} BDT</td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr>
                    <td colSpan={8} className="text-right">
                      <strong>Total Price</strong>
                    </td>
                    <td className="text-right">
                      <strong>{money(info.total_price)} BDT</strong>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={8} className="text-right">
                      <strong>Payment Amount</strong>
                    </td>
                    <td className="text-right">
                      <strong>{money(info.payment_amount)} BDT</strong>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={8} className="text-right">
                      <strong>Total Invoiced Amount</strong>
                    </td>
                    <td className="text-right">
                      <strong>{money(info.delivered_amount)} BDT</strong>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={8} className="text-right">
                      <strong>Remaining Amount</strong>
                    </td>
                    <td className="text-right">
                      <strong>{money(info.remaining_amount)} BDT</strong>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>

            {info.notes ? (
              <p style={{ fontSize: "13px" }}>
                <b>Note: </b>
                {info.notes}
              </p>
            ) : null}

            <div className="d-flex justify-content-between mt-5" style={{ fontWeight: "bold" }}>
              <span style={{ borderTop: "1px dotted black", padding: "5px 10px 0 10px" }}>Distributor&rsquo;s Signature</span>
              <span style={{ borderTop: "1px dotted black", padding: "5px 10px 0 10px" }}>Prepared By</span>
              <span style={{ borderTop: "1px dotted black", padding: "5px 10px 0 10px" }}>Checked By</span>
              <span style={{ borderTop: "1px dotted black", padding: "5px 10px 0 10px" }}>Approved By</span>
              <span style={{ borderTop: "1px dotted black", padding: "5px 10px 0 10px" }}>Depot In-Charge</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Receipt;
